/**
 * Parser pour les déclarations d'ingrédients INCO (texte libre de l'étiquette).
 *
 * Exemple d'entrée :
 *   "Riz thaï parfumé, poulet (28%), lait de coco, pâte de curry vert (piment, AIL, citronnelle), sauce SOJA, sel."
 *
 * Exemple de sortie :
 *   [
 *     { name: "Riz thaï parfumé", subItems: [], percent: null },
 *     { name: "Poulet", subItems: [], percent: 28 },
 *     { name: "Lait de coco", subItems: [], percent: null },
 *     { name: "Pâte de curry vert", subItems: ["Piment", "Ail", "Citronnelle"], percent: null },
 *     { name: "Sauce soja", subItems: [], percent: null },
 *     { name: "Sel", subItems: [], percent: null },
 *   ]
 */

// Split par virgule en respectant les parenthèses imbriquées
function splitTopLevelComma(text) {
  const parts = [];
  let depth = 0;
  let buf = "";
  for (const ch of text) {
    if (ch === "(" || ch === "[") depth += 1;
    else if (ch === ")" || ch === "]") depth = Math.max(0, depth - 1);
    if (ch === "," && depth === 0) {
      if (buf.trim()) parts.push(buf.trim());
      buf = "";
    } else {
      buf += ch;
    }
  }
  if (buf.trim()) parts.push(buf.trim());
  return parts;
}

// Capitalise la 1re lettre, le reste en minuscules. Conserve les particules.
function smartCase(s) {
  const t = s.trim();
  if (!t) return "";
  return t.charAt(0).toLocaleUpperCase("fr") + t.slice(1).toLocaleLowerCase("fr");
}

// Retire le pourcentage entre parenthèses sur le nom principal et le retourne séparément.
// Ex: "poulet (28%)" → { name: "poulet", percent: 28 }
function extractPercent(s) {
  const m = s.match(/\s*\(\s*(\d+(?:[.,]\d+)?)\s*%\s*\)\s*$/);
  if (m) {
    return {
      name: s.slice(0, m.index).trim(),
      percent: Number(m[1].replace(",", ".")),
    };
  }
  return { name: s.trim(), percent: null };
}

export function parseInco(text) {
  if (!text || typeof text !== "string") return [];
  // Nettoyage : retire les "Ingrédients :" en tête, point final, espaces multiples
  let clean = text
    .replace(/^\s*Ingr[ée]dients\s*:?\s*/i, "")
    .replace(/[.;]+\s*$/g, "")
    .replace(/\s+/g, " ")
    .trim();

  const parts = splitTopLevelComma(clean);
  const result = [];

  for (const raw of parts) {
    // Extrait les sous-ingrédients entre parenthèses (si la parenthèse ne contient PAS de %)
    const parenMatch = raw.match(/^(.+?)\s*\(([^()]+)\)\s*$/);
    let mainPart = raw;
    let subItemsRaw = null;

    if (parenMatch) {
      const inside = parenMatch[2].trim();
      // Si c'est juste un pourcentage, on garde tel quel pour extractPercent
      if (!/^\d+(?:[.,]\d+)?\s*%$/.test(inside)) {
        mainPart = parenMatch[1].trim();
        subItemsRaw = inside;
      }
    }

    const { name, percent } = extractPercent(mainPart);
    const cleanName = smartCase(name);
    if (!cleanName) continue;

    let subItems = [];
    if (subItemsRaw) {
      subItems = splitTopLevelComma(subItemsRaw)
        .map((s) => smartCase(extractPercent(s).name))
        .filter(Boolean);
    }
    result.push({ name: cleanName, subItems, percent });
  }
  return result;
}
